import { render, staticRenderFns } from "./OrderStatusInDeliveryIcon.vue?vue&type=template&id=56da0af4&scoped=true&"
import script from "./OrderStatusInDeliveryIcon.vue?vue&type=script&lang=js&"
export * from "./OrderStatusInDeliveryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da0af4",
  null
  
)

export default component.exports